import { useSentry } from '@/composables/utils/useSentry';
import { useValidationError } from '@/utils/typedError';
import type { ItineraryContactForm } from '@/wabunka-src/features/Itinerary/composables/form/itineraryContactForm';
import { buildItineraryContactFormRequestBody, createDefaultItineraryContactForm, validateItineraryContactForm } from '@/wabunka-src/features/Itinerary/composables/form/itineraryContactForm';
import { useSubmitItineraryContactMutation } from '@/wabunka-src/features/Itinerary/composables/mutation/useSubmitItineraryContactMutation';

export const useItineraryContactForm = () => {
  const { errors, getErrorMessage, setErrors, hasError } = useValidationError<ItineraryContactForm>();

  const isSending = ref<boolean>(false);
  const form = ref<ItineraryContactForm>(createDefaultItineraryContactForm());
  const { submitItineraryContactMutate } = useSubmitItineraryContactMutation();
  const { captureWabunkaException } = useSentry();

  const onSubmit = async (onSuccess: () => void): Promise<void> => {
    try {
      const detectedErrors = validateItineraryContactForm(form.value);
      if (detectedErrors.length > 0) {
        setErrors(detectedErrors);
        return;
      }

      if (isSending.value) {
        return;
      }
      isSending.value = true;

      const reqBody = buildItineraryContactFormRequestBody(form.value);
      await submitItineraryContactMutate(reqBody).finally(() => {
        setErrors([]);
      });
      onSuccess();
    } catch (e) {
      captureWabunkaException(e as Error);
      alert('An error occurred.');
    } finally {
      isSending.value = false;
    }
  };

  return { form, onSubmit, isSending, errors, getErrorMessage, hasError };
};
